import { render, staticRenderFns } from "./chatgpt.vue?vue&type=template&id=3d5f4060&scoped=true"
import script from "./chatgpt.vue?vue&type=script&lang=js"
export * from "./chatgpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f4060",
  null
  
)

export default component.exports